"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateList = validateList;
exports.notify = notify;
exports.instanceId = instanceId;
exports.generateId = generateId;
exports.isFirstFocusedRender = isFirstFocusedRender;
exports.getDefaultPopupContainerClass = getDefaultPopupContainerClass;
exports.setDefaultPopupContainerClass = setDefaultPopupContainerClass;
const lodash_1 = require("lodash");
const invariant_1 = __importDefault(require("invariant"));
const METHODS = ['next', 'prev', 'first', 'last'];
function validateList(list) {
    var _a;
    if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== 'production') {
        METHODS.forEach((method) => (0, invariant_1.default)(typeof list[method] === 'function', 'List components must implement a `' + method + '()` method'));
    }
}
function notify(handler, args) {
    handler === null || handler === void 0 ? void 0 : handler(...[].concat(args));
}
function instanceId(component, suffix = '') {
    var _a;
    component.__id = (_a = component.__id) !== null && _a !== void 0 ? _a : (0, lodash_1.uniqueId)('vdl_');
    return (component.props.id || component.__id) + suffix;
}
function generateId(props, suffix = '') {
    return props.id || ((0, lodash_1.uniqueId)('vdl_') + suffix);
}
function isFirstFocusedRender(component) {
    return component._firstFocus || (component.state.focused && (component._firstFocus = true));
}
let defaultPopupContainerClass = '';
function getDefaultPopupContainerClass() {
    return defaultPopupContainerClass;
}
function setDefaultPopupContainerClass(newClass) {
    defaultPopupContainerClass = newClass;
}
//# sourceMappingURL=widget-helpers.js.map